import { createSelector } from "reselect";

/**
 * create a selector to get the api context for admin users custom roles
 * @returns {function} selector
 */
export function createAdminUsersCustomRolesContextSelector() {
  return createSelector(
    () => {
      return "adminUsersCustomRoles";
    },
    context => {
      return context;
    }
  );
}
